
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Product } from "./ShopTypes";

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  return (
    <Card className="overflow-hidden hover:shadow-md transition-shadow hover-card">
      <CardContent className="p-0">
        <div className="grid grid-cols-1 md:grid-cols-3">
          <div className="aspect-square bg-mint-100 image-hover">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="col-span-2 p-4 md:p-6 flex flex-col">
            <h3 className="text-lg md:text-xl font-semibold mb-2">{product.name}</h3>
            <p className="text-sm md:text-base text-muted-foreground mb-4 line-clamp-3 md:line-clamp-none">
              {product.description}
            </p>
            <div className="mt-auto">
              <div className="flex justify-between items-center mb-3">
                <span className="font-medium text-base md:text-lg">{product.price}</span>
              </div>
              <Button asChild className="w-full button-hover pulse-on-hover">
                <a 
                  href={product.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Shop Now
                </a>
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
